import { render, staticRenderFns } from "./IssuesCreateModal.vue?vue&type=template&id=05b9a6e0"
import script from "./IssuesCreateModal.vue?vue&type=script&lang=js"
export * from "./IssuesCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports